import { updateItemInCollection } from "directus/src/operations";

export async function updateEntity({ item, entityId }) {
    try {
        const query = {
            fields: [
                "id",
                "name",
                "status",
                "organisation",
            ],
        };

        const data = await updateItemInCollection(
            "legal_entities",
            entityId,
            item,
            query
        );

        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}
